export default {
  'bulkRemove.title': 'Bulk Remove Roles { value }',
  'bulkRemove.button.remove': 'Remove',
  'bulkRemove.button.viewFullRoleDetails': 'View full role details',
  'bulkRemove.removeBy.heading': 'Bulk remove roles by',
  'bulkRemove.text.role': 'Role',
  'bulkRemove.text.organization': 'Organization',
  'bulkRemove.text.selectRole': 'Select Role',
  'bulkAssign.title': 'Bulk Assign Roles { value }',
  'bulkAssign.button.assign': 'Assign',
  'bulkAssign.message.successAssigned': 'Roles are assigned to Organizations',
  'bulkAssign.message.emptyOrganizations':
    'Please select at least one organization',
  'bulkAssign.message.emptyRoles': 'Please select at least one role',
  'bulkAssign.message.select_start_date': 'Please select start date',
  'bulkAssign.message.select_end_date': 'Please select end date',
  'bulkAssign.message.select_start_end_date': 'Please select start & end date'
};
